import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user.service';

@Component
export default class Confirmation extends Vue {
  public hasGivenUp: boolean = false;

  protected created() {
    this.hasGivenUp = this.$store.state.hasGivenUp ? true : false;
  }

  protected mounted() {
    UserService.clearData();
    UserService.logout();

    // Empty all data relative to the previous dossier that was confirmed
    this.$store.commit('resetDossierState');
  }
}

